import {
  Component,
  ContentChildren,
  QueryList,
  AfterViewInit,
  signal,
  output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabComponent } from './tab/tab.component';

@Component({
  selector: 'app-tabs',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tabs.component.html',
})
export class TabsComponent implements AfterViewInit {
  @ContentChildren(TabComponent) tabs!: QueryList<TabComponent>;
  tabChange = output<TabComponent>();

  activeTab = signal<TabComponent | undefined>(undefined);

  ngAfterViewInit() {
    this.selectTab(this.tabs.first);
  }

  selectTab(tab: TabComponent) {
    this.activeTab.set(tab);
    this.tabChange.emit(tab);
  }
}
